<template>
  <div class="paintings">
    <navigation></navigation>

    <!-- Circle Preloader -->
    <h3>Paintings</h3>

    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/SelbstaufderSuche.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Selbst auf der Suche</i><br />
              150 x 113 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Hütte.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Hütte</i><br />
              50 x 40 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/GartenEden.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Garten Eden</i><br />
              170 x 120 cm, oil on canvas
            </p>
          </div>
        </div>
        <!-- end row 1 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Dichtung.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Dichtung 1</i><br />
              70 x 60 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Tilidin.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Tilidin</i><br />
              70 x 50 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/NewWave.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>New Wave</i><br />
              70 x 50 cm, oil on canvas
            </p>
          </div>
        </div>
        <!-- end row 2 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Werbinich.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Wer bin ich?</i><br />
              150 x 113 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/EntertheVoid.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Selbst auf der Suche</i><br />
              24 x 18 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/kings.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Kings</i><br />
              40 x 30 cm, oil on canvas
            </p>
          </div>
        </div>
        <!-- end row 3 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Gurkenmaske.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Gurkenmaske</i><br />
              70 x 50 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/HelloagainBorner.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Hello again Borner</i><br />
              70 x 60 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/DasgoldeneKalb.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Das goldene Kalb</i><br />
              50 x 70 cm, oil on canvas
            </p>
          </div>
        </div>
        <!-- end row 4 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Bohren.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bohren & der Club of Gore</i><br />
              50 x 40 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Allways.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Allways 1- 4</i><br />
              50 x 40 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/KönigLudwig.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>König Ludwig</i><br />
              30 x 40 cm, oil on canvas
            </p>
          </div>
        </div>
        <!-- end row 5 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Wannistmanschonallein.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Wann ist man schon allein?</i><br />
              70 x 50 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/X-large.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>X-large</i><br />
              40 x 40 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Poseidon.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Poseidon</i><br />
              100 x 70 cm, oil on canvas
            </p>
          </div>
        </div>
        <!-- end row 6 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Skull5.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Skull 5</i><br />
              40 x 30 cm, oil on canvas
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/paintings/Selbstbildnis.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Selbstbildnis</i><br />
              40 x 30 cm, oil on canvas
            </p>
          </div>
        </div>

        <!-- end row 7 -->
      </div>
      <!-- -->
    </div>

    <!--container end div-->
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
